import { z } from 'zod';
import { modalRef, ModalRefType, ModalType } from './ref/modalRef';
import { AthenaCore } from './athena-core';

const ROUTE_WHITELIST = new Set([
  '/',
  '/projects',
  '/calendar',
  '/contact',
  '/verify',
  '/payment',
  '/payment-status',
]);

const MODAL_TYPE_WHITELIST: ReadonlyArray<ModalType> = [
  'info',
  'warning',
  'error',
  'success',
];

export const OpenModalSchema = z.object({
  title: z.string().max(80),
  message: z.string().max(500),
  type: z.enum(['info', 'warning', 'error', 'success']).optional(),
});

export const RedirectSchema = z.object({ path: z.string() });

export const ReportPulseSchema = z.object({
  label: z.string(),
  details: z.record(z.string(), z.unknown()).optional(),
});

type UICommand =
  | { kind: 'OPEN_MODAL'; title: string; message: string; type?: ModalType }
  | { kind: 'ERROR'; status: number; title: string; message: string }
  | { kind: 'REDIRECT'; path: string }
  | { kind: 'PULSE'; label: string; details?: Record<string, unknown> };

let HITL_PAUSED = false;
export function setHITLPaused(v: boolean) {
  HITL_PAUSED = v;
}

export async function dispatch(
  cmd: UICommand,
  opts?: { requireApproval?: boolean }
) {
  if (opts?.requireApproval || HITL_PAUSED) {
    AthenaCore.sealLog('HITL_PAUSED_PENDING', { cmd });
    AthenaCore.throwError({
      status: 425,
      message: 'HITL approval required',
      meta: { cmd },
    }); // 425 Too early
  }

  switch (cmd.kind) {
    case 'ERROR':
      AthenaCore.throwError({
        status: 500,
        message: cmd.message,
      });
      break;

    case 'OPEN_MODAL':
      if (cmd.type && !MODAL_TYPE_WHITELIST.includes(cmd.type))
        AthenaCore.throwError({
          status: 400,
          message: `Invalid modal type: ${cmd.type}`,
        });
      AthenaCore.openModal({
        title: cmd.title,
        message: cmd.message,
        type: cmd.type,
      });
      break;

    case 'REDIRECT':
      AthenaCore.guardRoute(cmd.path);
      AthenaCore.redirect(cmd.path);
      break;

    case 'PULSE':
      AthenaCore.reportPulse(cmd.label, cmd.details);
      break;
  }
}
